module.exports = __webpack_public_path__ + "img/video.61fbc882.svg";